import { ProxyAddressStore } from './schema/ProxyAddressStore';
import { createStore } from 'satcheljs';

const proxyAddressStoreData: ProxyAddressStore = {
    availableProxyAddresses: null,
};

export const getStore = createStore<ProxyAddressStore>('proxyaddresses', proxyAddressStoreData);

export const proxyAddressStore = getStore();
